export interface ActionRailItem {
  id: string;
  num: string;
  label: string;
  hint?: string;
}

interface ActionRailProps {
  items: readonly ActionRailItem[];
  current?: string | null;
  onPick: (id: string) => void;
}

export function ActionRail({ items, current = null, onPick }: ActionRailProps) {
  return (
    <div className="action-rail">
      {items.map((it) => (
        <button
          key={it.id}
          className={`action-rail__item ${current === it.id ? "is-current" : ""}`}
          onClick={() => onPick(it.id)}
        >
          <span className="t-mono action-rail__num">{it.num}</span>
          <span className="action-rail__label">{it.label}</span>
          {it.hint && <span className="action-rail__hint t-mono">{it.hint}</span>}
        </button>
      ))}
    </div>
  );
}
